import { environmentSwitch, SegFlags } from "../../../providers";
import { icon } from "../../icon-component";

export const FILTER_TYPE = {
	SIMPLE_LIST: "SIMPLE_LIST",
	TREE: "TREE",
	BOOLEAN: "BOOLEAN",
	TEXT_FIELD: "TEXT_FIELD",
};

const VERSION_ITEMS = {
	NEW: {
		label: "common:filters.select-filter.menus.new-content",
		iconName: icon.faPlusCircle,
		color: "var(--blue-500)",
		description: "common:filters.select-filter.menus.new-content.description",
		key: "NEW",
	},
	MAJOR: {
		label: "common:filters.select-filter.menus.major-modifications",
		iconName: icon.faExclamationTriangle,
		color: "var(--red-500)",
		description: "common:filters.select-filter.menus.major-modifications.description",
		key: "MODIFIED",
	},
	MINOR: {
		label: "common:filters.select-filter.menus.minor-modifications",
		iconName: icon.faExclamationTriangle,
		color: "var(--color-keppel)",
		description: "common:filters.select-filter.menus.minor-modifications.description",
		key: "MODIFIED_MINOR",
	},
	IDENTICAL: {
		label: "common:filters.select-filter.menus.identical-content",
		iconName: icon.aitEqualsCircle,
		color: "var(--grey-600)",
		description: "common:filters.select-filter.menus.identical-content.description",
		key: "IDENTICAL",
	},
};
const REQUIREMENT_ITEMS = {
	EXPLICIT: {
		label: "common:filters.select-filter.menus.explicit",
		description: "common:filters.select-filter.menus.explicit-description",
		key: "isClientRequirement",
	},
	AI: {
		label: "common:filters.select-filter.menus.ai",
		description: "common:filters.select-filter.menus.ai-description",
		key: "isAIRequirement",
		segFlag: SegFlags.AI_IMPLICIT_REQUIREMENT_DETECTOR,
	},
	IMPLICIT: {
		label: "common:filters.select-filter.menus.implicit",
		description: "common:filters.select-filter.menus.implicit-description",
		key: "isRequirement",
	},
};
const IMPACT_ITEMS = {
	ORPHANED: {
		label: "common:filters.select-filter.menus.orphaned",
		key: "ORPHANED",
	},
};

const COMMON_COMMENT_ITEMS = {
	AUTHOR: {
		label: "common:comment.own-comments",
		key: "iamTheWriter",
	},
	REPLIED: {
		label: "common:comment.my-replies",
		key: "isReplied",
	},
};
const ADDITIONAL_COMMENT_ITEMS = {
	MENTIONED: {
		label: "common:comment.my-mentions",
		key: "iamMentionedIn",
	},
};

export default {
	VERSION: {
		iconName: icon.aitClipBoardCheck,
		filterKey: "infoversion",
		label: "common:filters.select-filter.menus.info-version",
		type: FILTER_TYPE.SIMPLE_LIST,
		multiSelection: true,
		items: VERSION_ITEMS,
	},
	IMPACT: {
		filterKey: "impact",
		iconName: icon.faExclamationTriangle,
		label: "common:filters.select-filter.menus.impact",
		type: FILTER_TYPE.SIMPLE_LIST,
		multiSelection: true,
		items: IMPACT_ITEMS,
	},
	LINKS: {
		iconName: icon.faLink,
		filterKey: "links",
		label: "common:filters.select-filter.menus.link-types",
		type: FILTER_TYPE.SIMPLE_LIST,
		multiSelection: true,
	},
	QUALITY_PROGRESS: {
		filterKey: "qualityprogress",
		label: "common:filters.select-filter.menus.quality-progress",
		type: FILTER_TYPE.SIMPLE_LIST,
		multiSelection: false,
	},
	CRITICALITY: {
		filterKey: "reqCriticality",
		iconName: icon.faExclamationCircle,
		label: "common:filters.select-filter.menus.req-criticality",
		type: FILTER_TYPE.SIMPLE_LIST,
		multiSelection: true,
	},
	NEGOTIABILITY: {
		filterKey: "reqNegotiability",
		iconName: icon.faHandshakeAngle,
		label: "common:filters.select-filter.menus.req-negotiability",
		type: FILTER_TYPE.SIMPLE_LIST,
		multiSelection: true,
	},
	TYPE: {
		filterKey: "reqType",
		iconName: icon.faAsterisk,
		label: "common:filters.select-filter.menus.req-type",
		type: FILTER_TYPE.SIMPLE_LIST,
		multiSelection: true,
	},
	PROJECT: {
		filterKey: "projects",
		iconName: icon.faHammer,
		label: "navigation:common.projects",
		hasClearSelection: true,
		hasSearch: true,
	},
	REQUIREMENT: {
		filterKey: "requirement",
		iconName: icon.faAsterisk,
		label: "common:filters.requirement.title",
		description: "common:component.filters.helper.only-items-with-results",
		type: FILTER_TYPE.SIMPLE_LIST,
		items: REQUIREMENT_ITEMS,
		hasIsSeparator: true,
	},
	DOCUMENTS: {
		filterKey: "documents",
		iconName: icon.faFile,
		label: "common:filters.select-filter.menus.document",
		description: "common:component.filters.helper.only-items-with-results",
		multiSelection: true,
		hasIsSeparator: true,
		hasSearch: true,
		minSearch: 2,
		labelSearch: "Role",
	},
	CATEGORIES: {
		filterKey: "categories",
		iconName: icon.faSitemap,
		label: "common:categories",
		multiSelection: true,
		hasIsSeparator: true,
		hasSearch: true,
		hasAndOrOperator: true,
	},
	TOC: {
		filterKey: "tocFilters",
		iconName: icon.faHeading,
		label: "common:filters.select-filter.menus.document.toc",
		dynamicLabel: "common:filters.keywords.label-active.toc",
		disabledOptionTooltip: "common:filters.keywords.disable-negative-filters.toc.at-least-one-positive",
	},
	KEYWORDS: {
		filterKey: "keywordFilters",
		iconName: icon.faAlignCenter,
		label: "common:filters.select-filter.menus.content.paragraph",
		dynamicLabel: "common:filters.keywords.label-active.paragraph",
		disabledOptionTooltip: "common:filters.keywords.disable-negative-filters.paragraph.at-least-one-positive",
	},
	INFORMATION_ID: {
		filterKey: "informationIds",
		iconName: icon.faHashtag,
		label: "common:filters.select-filter.menus.content.information",
		hasIsSeparator: true,
	},
	POSITIONS: {
		filterKey: "positionsFilter",
		iconName: icon.faCheckToSlot,
		label: "common:filters.select-filter.menus.positions",
		hasClearSelection: true,
	},
	DELIVERABLES: {
		filterKey: "deliverables",
		iconName: icon.faFileSignature,
		label: "common:filters.select-filter.menus.deliverables",
		hasIsSeparator: true,
		hasSearch: true,
		hasAndOrOperator: true,
	},
	USERS: {
		filterKey: "users",
		label: "common:filters3.users.label",
		iconName: icon.faUser,
		multiSelection: true,
		hasSearch: true,
		hasClearSelection: true,
	},
	TAGS: {
		filterKey: "tags",
		label: "common:filters3.tags.label",
		iconName: icon.faTag,
		multiSelection: true,
		hasSearch: true,
		hasClearSelection: true,
	},
	CLIENT_REF: {
		filterKey: "clientRef",
		iconName: icon.faUser,
		label: "common:filters.select-filter.menus.req-details.client-ref",
		type: FILTER_TYPE.TEXT_FIELD,
	},
	SEARCH_CARD: {
		filterKey: "searchCard",
		label: "common:filters3.search-cards.label",
		multiSelection: true,
		hasSearch: true,
	},
	ALLOCATE: {
		filterKey: "isNotAllocated",
		label: "common:enum.coverage-status.not-allocated",
		type: FILTER_TYPE.BOOLEAN,
	},
	STAKE_HOLDING: {
		filterKey: "stakeHolding",
		label: "dashboards.task-dashboard.my-tasks",
		type: FILTER_TYPE.BOOLEAN,
	},
	OWNING: {
		filterKey: "owning",
		label: "dashboards.task-dashboard.supervising",
		type: FILTER_TYPE.BOOLEAN,
	},
	TO_BE_TESTED: {
		filterKey: "isToBeTested",
		label: "common:enum.coverage-status.to-be-tested",
		type: FILTER_TYPE.BOOLEAN,
	},
	EXCLUDED: {
		filterKey: "isExcluded",
		trueLabel: "common:enum.coverage-status.excluded",
		falseLabel: "common:enum.coverage-status.to-be-covered",
		type: FILTER_TYPE.BOOLEAN,
	},
	PROJECT_COMMENTS: {
		filterKey: "projectComments",
		iconName: icon.faComment,
		label: "common:comment.my-comments",
		type: FILTER_TYPE.SIMPLE_LIST,
		items: { ...COMMON_COMMENT_ITEMS, ...environmentSwitch({ main: ADDITIONAL_COMMENT_ITEMS, veolia: {} }) },
	},
	PHASES: {
		filterKey: "phases",
		iconName: icon.faTag,
		label: "common:phases",
		multiSelection: true,
		hasIsSeparator: true,
		hasSearch: true,
		hasAndOrOperator: true,
	},
	OWNERS: {
		filterKey: "owners",
		label: "common:owners",
		iconName: icon.faUser,
		multiSelection: true,
		hasSearch: true,
		hasClearSelection: true,
	},
};
